import { call, put, takeLatest } from 'redux-saga/effects';
import { companyGetAllDepartments } from '@/api-gen/api.ts';
import {
  getAllDepartments,
  getAllDepartmentsSuccess,
  getAllDepartmentsFailure
} from 'app/actions/companyManagment/departmentActions.ts';

function* getAllDepartmentsSaga() {
  try {
    const response: Awaited<ReturnType<typeof companyGetAllDepartments>> = yield call(companyGetAllDepartments);
    yield put(getAllDepartmentsSuccess(response.data));
  } catch (error) {
    yield put(getAllDepartmentsFailure(error instanceof Error ? error.message : 'Failed to fetch all departments'));
  }
}

export function* departmentSaga() {
  yield takeLatest(getAllDepartments.type, getAllDepartmentsSaga);
}
